import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
  activeLanguage: string;
}

const initialState: IInitialState = {
  activeLanguage: 'en_US',
};

const campaignVisibilitySlice = createSlice({
  initialState,
  name: 'campaignVisibility',
  reducers: {
    resetActiveLanguage(state: IInitialState) {
      state.activeLanguage = initialState.activeLanguage;
    },
    setActiveLanguage(
      state: IInitialState,
      action: PayloadAction<IInitialState['activeLanguage']>
    ) {
      state.activeLanguage = action.payload;
    },
  },
});

export default campaignVisibilitySlice.reducer;

export const { setActiveLanguage, resetActiveLanguage } =
  campaignVisibilitySlice.actions;
